import translate from '@translate';
import React, { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setLocationParams } from 'src/resources/location/reducer';
import { RootStoreType } from 'src/types/store';
import Loading from 'src/components/Loading/intex';
import {
    getProductStockTransfersDetailFetch,
    clearProductStockTransfersDetail,
} from 'src/resources/productStockTransfersDetail/reducer';
import ProductStockTransfersTable from './ProductStockTransfersTable';
import getBackUrl from 'src/utils/getBackUrl';

const ProductStockTransfersDetailContainer: FC = () => {
    const dispatch = useDispatch();

    const { idProduct } = useParams();

    const data = useSelector((state: RootStoreType) => state.productStockTransfersDetail.data);
    const loading = useSelector((state: RootStoreType) => state.productStockTransfersDetail.loading);
    const locationHistory = useSelector((state: RootStoreType) => state.location.history);

    const backUrl = getBackUrl(locationHistory, '/products/active/');

    useEffect(() => {
        dispatch(setLocationParams({ name: translate('productStockTransfersDetail.title', { idProduct }), backUrl }));
    }, [idProduct, backUrl, locationHistory]);

    useEffect(() => {
        if (idProduct) {
            dispatch(getProductStockTransfersDetailFetch(idProduct));
        }
        return () => {
            dispatch(clearProductStockTransfersDetail());
        };
    }, [idProduct]);

    return (
        <>
            {loading && <Loading />}
            <ProductStockTransfersTable data={data} />
        </>
    );
};

export default ProductStockTransfersDetailContainer;
